const MAX_FILE_BYTES = 20 * 1024 * 1024; // 20 MB

export function validateFile(file: File): string | null {
  if (file.size > MAX_FILE_BYTES) {
    const sizeMB = (file.size / (1024 * 1024)).toFixed(1);
    return `File too large (${sizeMB} MB). Maximum size is 20 MB.`;
  }
  return null;
}
